import React from "react";
import LocationData from "../../../Assets/Data/maps";

const MapItems = ({ setMarkers }) => {
  return (
    <div className="mapItems">
      {Object.entries(LocationData).map(([name, places], i) => (
        <div className="itemGroup" key={`item-group-${i}`}>
          <h2 onClick={() => setMarkers(places)}>{name}</h2>
          <ul>
            {places.map(({ name, lat, long }, j) => (
              <li
                key={`item-group-${i}-item-${j}`}
                onClick={() => setMarkers([{ name, lat, long }])}
              >
                {name}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default MapItems;
